import { render, staticRenderFns } from "./CustomOccupationModalForm.vue?vue&type=template&id=3741b666&"
import script from "./CustomOccupationModalForm.vue?vue&type=script&lang=js&"
export * from "./CustomOccupationModalForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomOccupationModalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default})
